<template>
  <div class="d-calendar__column w-100 position-relative">
    <div class="d-calendar__title"
         v-if="item && item.type === 'doctor'"
         :id="`doctor-popover-${dayFormatted}-${item.item.id}`"
         :style="{ backgroundColor: item.item.color }">
      <a class="pointer" :style="{ color: clinic.calendar_color ? clinic.calendar_color : 'white' }">
        <img class="round-img mr-2"
             @click="(...args) => doctorMouseEnter(item.item, ...args)"
             :style="{ borderColor: item.item.color }"
             :src="item.item.photo"
             alt=""/>
        <span @click="(...args) => doctorMouseEnter(item.item, ...args)">{{ item.title }}</span>
        <span @click="selectDoctor"
              class="ml-1 d-inline-block doctor-schedule-in-calendar-header"
              v-if="schedule">{{ schedule }}</span>
      </a>

      <a @click.stop="editDoctorSchedule(null, null)"
         v-if="canEditSchedule"
         class="pl-md-2 pl-1 pr-1 pointer"
         style="margin-bottom: 3px">
        <EditSvg class="svg-size-sm svg-white"/>
<!--        <EditSvg class="svg-size-sm svg-stroke-white"/>-->
      </a>
    </div>
    <DoctorHoverCalendar :doctor="doctorHovered"
                         v-if="showPopover && item.item && doctorHovered && doctorHovered.id === item.item.id"
                         class="doctor-popover"
                         :class="{ 'left': index === 0, 'right': index > 0 && (index + 1) === count }"
                         v-click-outside="clickedOutside"
                         :day="day"/>

    <div v-if="item && item.type !== 'doctor'"
         class="d-calendar__title">
      <div class="w-100 h-100 d-flex flex-column justify-content-center">
        <div>
          <a v-if="item.type == 'day'"
             tabindex="#"
             class="pointer"
             @click="navigateToDay">
            {{ item.title }}
            <span v-if="isToday(item)" class="ml-1 today-bubble"></span>
          </a>
          <span v-else>{{ item.title }}</span>
          <a @click.stop="editChairSchedule"
             v-if="curView == 'CHAIR' && rights.includes('work_time_edit')"
             class="chair-schedule-btn pointer position-absolute"
             style="right: 5px; top: 2px;">
            <ScheduleSvg/>
          </a>
        </div>
        <div v-if="item.type === 'chair' && doctorsWithScheduleForChair.length > 0"
             style="flex: 2"
             class="d-flex flex-column">
          <div v-for="(d, dind) in doctorsWithScheduleForChair"
               :key="`chair-title-${item.id}-${dind}`"
               @click="(...args) => doctorMouseEnter(d, ...args)"
               class="pointer"
               :id="`doctor-popover-${day}-${d.id}`"
               style="flex: 1">
            <div class="doctor-col h-100 d-flex flex-column justify-content-center"
                 :style="{ backgroundColor: d.color }"
                 :class="{ 'hasColor': d.color, oneLiner: oneLiner || smallCol, smallCol }">
              <div class="row no-gutters align-items-center flex-nowrap">
                <div class="col-auto" v-if="colWidth >= 178">
                  <img class="round-img mr-2" :src="d.photo" alt=""/>
                </div>
                <div class="col text-left">
                  <div class="row align-items-center no-gutters" :style="{ color: clinic.calendar_color ? clinic.calendar_color : 'white' }">
                    <div :class="{ 'col-12': smallCol || !oneLiner }"
                         class="doctor-chair-title"
                         :style="{ maxWidth: `${(colWidth < 178 ? (colWidth - 10) : (colWidth - 40))}px`}">
                      {{ d.full_name }}
                    </div>
                    <div :class="{
                      'col-12': smallCol || !oneLiner,
                      'col-auto pl-2': !smallCol && oneLiner
                    }">
                        <span style="opacity: 0.7;"
                              :style="{ width: smallCol || !oneLiner ? 'auto' : 65+'px' }"
                              class="d-block">
                          {{ getDoctorSchedule(d.id, item) }}
                        </span>
                    </div>
                    <div v-if="d.blocks && d.blocks.length" :class="{
                      'col-12': smallCol || !oneLiner,
                      'col-auto pl-2': !smallCol && oneLiner
                    }">
                      <span v-for="(block, blockIndex) in d.blocks"
                            class="mr-1"
                            v-b-tooltip.hover
                            :title="$t('block_noun')"
                            :key="`block-${d.id}-${blockIndex}`">⛔️ {{ block }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DoctorHoverCalendar :doctor="doctorHovered"
                               v-if="showPopover && doctorHovered"
                               v-click-outside="clickedOutside"
                               class="doctor-popover"
                               :chair="item"
                               :day="day"/>
        </div>
      </div>
    </div>

    <div v-if="!item" class="d-calendar__title">
      {{ $t('no_schedule') }}
      <a @click.stop="editChairSchedule"
         v-if="curView == 'CHAIR'"
         class="chair-schedule-btn pointer position-absolute"
         style="right: 5px; top: 2px;">
        <ScheduleSvg/>
      </a>
    </div>
  </div>
</template>

<script>
import ColumnTitle from "@/components/pages/calendar/calendar/classes/ColumnTitle"
import {mapGetters, mapState} from "vuex"
import moment from "moment-timezone"
import EditSvg from '@/assets/svg-vue/general/edit_s0.svg'
// import EditSvg from '@/assets/svg-vue/general/edit2.svg'
import ScheduleSvg from '@/assets/svg-vue/calendar/add_schedule.svg'
import DoctorHoverCalendar from "@/components/parts/calendar/DoctorHoverCalendar.vue"
import {copyObject} from "@/extensions/prototypes/prototypes"

export default {
  name: "DColumnTitle",
  components: {
    DoctorHoverCalendar,
    EditSvg,
    ScheduleSvg
  },
  props: {
    item: ColumnTitle,
    day: {},
    colWidth: {},
    index: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      doctorHovered: null,
      showPopover: false,
      justOpened: false
    }
  },
  computed: {
    ...mapState({
      curView: state => state.calendar.curView,
      doctorSchedules: state => state.calendar.doctorSchedules,
      staffSchedules: state => state.calendar.staffSchedules,
      doctorBlocks: state => state.calendar.doctorBlocks,
      doctors: state => state.calendar.doctors,
      staff: state => state.calendar.staff,
      clinic: state => state.auth.clinic,
      user: state => state.auth.user,
      rights: state => state.auth.rights,
      selectedProfessions: state => state.calendar.selectedProfessions,
      scheduleView: state => state.calendar.scheduleView,
    }),
    ...mapGetters([
      'doctorHasProfession',
      'staffScheduleEditRight'
    ]),
    schedule() {
      if(this.item.type !== 'doctor') return ''
      return this.getDoctorSchedule(this.item.id)
    },
    employeeSchedules() {
      if(this.scheduleView !== 'doctors') return this.staffSchedules
      return this.doctorSchedules
    },
    dayFormatted() {
      return moment(this.day).format('YYYY-MM-DD')
    },
    doctorsWithScheduleForChair() {
      if(this.item.type !== 'chair') return []
      return this.doctors
          .filter(d => this.doctorSchedules && this.doctorSchedules[d.id] && this.getDoctorSchedule(d.id, this.item) && this.doctorFitsProfession(d))
          .map(d => ({ ...d, blocks: this.doctorBlocks[d.id] || [] }))
          .sort((a, b) => {
            const schedulesA = this.doctorSchedules[a.id].filter(s => s.day === this.dayFormatted)
            const schedulesB = this.doctorSchedules[b.id].filter(s => s.day === this.dayFormatted)
            if(!schedulesB || !schedulesB.length) return 1
            if(!schedulesA || !schedulesA.length) return -1
            return (schedulesA[0].time_from > schedulesB[0].time_from) ? 1 : -1
          })
    },
    smallCol() {
      return this.colWidth < 150
    },
    oneLiner() {
      return this.doctorsWithScheduleForChair.length > 1
    },
    canEditSchedule() {
      if(this.scheduleView === 'doctors') {
        if(this.item.type === 'doctor' && this.rights.includes('edit_own_schedule') && this.item.id === this.user.id) {
          return true
        }
        return this.rights.includes('work_time_edit')
      }
      return this.rights.includes(this.staffScheduleEditRight)
    }
  },
  methods: {
    navigateToDay() {
      this.$store.commit('goToDate', this.item.date)
    },
    selectDoctor() {
      const newList = this.doctors.filter(doc => doc.id === this.item.id)
      this.$store.commit('setSelectedDoctors', newList)
      this.$store.commit('setDoctors', this.copyObject(this.doctors))
    },
    getDoctorSchedule(doctor_id, chair = null) {
      let res = []
      if(this.doctorSchedules && this.doctorSchedules[doctor_id]) {
        this.doctorSchedules[doctor_id].forEach((sch) => {
          if(sch.time_from && sch.time_to && sch.day == this.dayFormatted) {
            if(chair && sch.chair_id && sch.chair_id != chair.id) return; // schedule has specific chair and it's not it.
            if(chair && !sch.chair_id && !chair.item.doctors.find(d => d.id === doctor_id)) return; // specific chair is not populated for doctor schedule, and he is not assigned to chair
            res.push(`${sch.time_from.substring(0,5)} - ${sch.timeToAdjusted.substring(0,5)}`)
          }
        })
      }
      return res.sort().join(', ')
    },
    doctorFitsProfession(doctor) {
      if(!this.selectedProfessions || !this.selectedProfessions.length) return true
      return this.doctorHasProfession(doctor)
    },
    async editChairSchedule() {
      if(!this.item) {
        await this.editDoctorSchedule(null, null)
        return
      }
      const doctors = this.doctors.filter(d => {
        return this.doctorSchedules && this.doctorSchedules[d.id] && this.getDoctorSchedule(d.id, this.item) && this.doctorFitsProfession(d)
      })
      if(!doctors.length) {
        await this.editDoctorSchedule(null, this.item)
        return
      }
      const schedules = []
      for (const d of doctors) {
        const schedule = this.copyObject(this.doctorSchedules[d.id].filter(x => x.day === this.dayFormatted && (!x.chair_id || Number(x.chair_id) === this.item.id)))
        schedule.map(s => s.chair_id = this.item.id)
        schedules.push(schedule)
        this.$store.commit('setDoctor', d)
      }
      this.$store.commit('setDoctorPreconfig', schedules.flat())
      this.$store.commit('setDoctorScheduleDay', this.day)
      await this.$nextTick()
      this.$bvModal.show('doctor-day-edit-modal')
    },
    async editDoctorSchedule(employee = null, chair = null) {
      if(!employee && this.item) {
        if(this.scheduleView === 'doctors') {
          employee = this.doctors.find(doc => doc.id === this.item.id)
        } else {
          employee = this.staff.find(obj => obj.id === this.item.id)
        }
      }
      let schedule = []
      if(employee && this.employeeSchedules && this.employeeSchedules[employee.id]) {
        schedule = copyObject(this.employeeSchedules[employee.id].filter(x => x.day === this.dayFormatted))
        if(chair) schedule.map(s => s.chair_id = chair.id)
        this.$store.commit('setDoctorPreconfig', schedule)
      }
      if(!schedule.length) {
        this.$store.commit('setDoctorPreconfig', [{
          day: moment(this.day).format('YYYY-MM-DD'),
          doctor_id: employee?.id || null,
          chair_id: chair ? chair.id : (employee && employee.chairs?.length ? employee.chairs[0].id : null),
          time_from: this.$store.state.calendar.timeFromHour.toString().padStart(2, '0') + ':00:00',
          time_to: this.$store.state.calendar.timeToHour.toString().padStart(2, '0') + ':00:00',
        }])
      }
      this.$store.commit('setDoctor', employee)
      this.$store.commit('setDoctorScheduleDay', this.day)
      await this.$nextTick()
      this.$bvModal.show('doctor-day-edit-modal')
    },
    doctorMouseEnter(doctor, e) {
      e.preventDefault()
      if(this.scheduleView !== 'doctors') {
        return
      }
      this.justOpened = true
      setTimeout(() => { this.justOpened = false },20)
      if(this.doctorHovered && this.doctorHovered.id === doctor.id) {
        this.doctorHovered = null
        this.showPopover = false
        return
      }
      this.doctorHovered = doctor
      this.showPopover = true
    },
    clickedOutside() {
      if(!this.justOpened) {
        this.doctorHovered = null
        this.showPopover = false
      }
    },
    isToday(item) {
      return item.type === 'day' && item.date && moment(item.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped lang="scss">
.d-calendar__column:last-child {
  border-right: 1px solid #E5E5E5;
}
.round-img {
  width: 22px;
  height: 22px;
  border-width: 2px;
  border-style: solid;
}
.today-bubble {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  display: inline-block;
  background: $green-color;
}
.d-calendar__title {
  background-color: #F2F6FA;
  font-size: 13px;
  border-left: 1px solid #B5C6D8;
  text-align: center;
  height: 100%;
  display: flex;
  word-break: break-word;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  position: relative;
  /*padding: 3px 5px;*/
  padding: 3px 0 0 0;
  // transition: all 0.2s ease-out;
  -webkit-box-shadow: 0px 7px 13px -10px rgba(34, 60, 80, 0.2) inset;
  -moz-box-shadow: 0px 7px 13px -10px rgba(34, 60, 80, 0.2) inset;
  box-shadow: 0px 7px 13px -10px rgba(34, 60, 80, 0.2) inset;
  .chair-schedule-btn {
    display: none;
    svg {
      width: 15px;
      height: 15px;
    }
  }
  &:hover {
    .chair-schedule-btn {
      display: inline-block;
    }
  }
}
.d-calendar__title, .d-calendar__title a {
  color: #5D6D7C;
}
.doctor-col {
  padding: 2px 5px;
  border-radius: 2px;
  font-size: 11px;
  &.hasColor {
    color: #fff;
  }
  .doctor-chair-title {
    white-space: nowrap;
    overflow:hidden;
    text-overflow: ellipsis;
  }
  &.smallCol {
    .doctor-chair-title {
      white-space: normal;
    }
  }
}
.doctor-popover {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 4;
  &.left {
    left: 0;
    transform: none;
  }
  &.right {
    right: 0;
    left: auto;
    transform: none;
  }
}
@media screen and (max-width: 768px) {
  .d-calendar__title {
    font-size: 12px;
    .doctor-col {
      font-size: 10px;
    }
  }
  .today-bubble {
    width: 7px;
    height: 7px;
  }
}
</style>
